// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");

function MyClientsWidgetRowLayout(props) {
  return JsxRuntime.jsxs("li", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.name,
        className: "flex gap-x-4 pr-6 sm:w-1/2 sm:flex-none"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          props.status,
          props.menu
        ],
        className: "flex items-center justify-between gap-x-4 sm:w-1/2 sm:flex-none"
      })
    ],
    className: "relative flex justify-between py-4"
  });
}

let make = MyClientsWidgetRowLayout;

exports.make = make;
/* react/jsx-runtime Not a pure module */
